import React from 'react'
import IconButton from 'material-ui/IconButton'
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert'
import IconMenu from 'material-ui/IconMenu'
import Divider from 'material-ui/Divider'
import { Link } from 'react-router'



import FlatButton from 'material-ui/FlatButton'
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'
import Colors from 'material-ui/styles/colors'
import {List, ListItem} from 'material-ui/List'

import Avatar from 'material-ui/Avatar'
import AutoComplete from 'material-ui/AutoComplete'
import DatePicker from 'material-ui/DatePicker'
import TextField from 'material-ui/TextField'
import Slider from 'material-ui/Slider'
import DropDownMenu from 'material-ui/DropDownMenu'
import Checkbox from 'material-ui/Checkbox'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import ContentAdd from 'material-ui/svg-icons/content/add'
import Moment from 'moment'

import { sortTasks } from 'utils/stuff'


let chDone = "/manager/static/img/res/ch_green.png"
let chWip = "/manager/static/img/res/ch_black.png"
let chPending = "/manager/static/img/res/ch_gray.png"


export default (o) => (
	<ListItem
		primaryText={(o.data[o.props.userID])? o.data[o.props.userID].name : 'Admin'}
		secondaryTextLines={2}
		secondaryText={
			o.props.body.split('\n').map(
				(row, indexRow) => {
					let urlRegex = /((?:(http|https|Http|Https|rtsp|Rtsp):\/\/(?:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,64}(?:\:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,25})?\@)?)?((?:(?:[a-zA-Z0-9][a-zA-Z0-9\-]{0,64}\.)+(?:(?:aero|arpa|asia|a[cdefgilmnoqrstuwxz])|(?:biz|b[abdefghijmnorstvwyz])|(?:cat|com|coop|c[acdfghiklmnoruvxyz])|d[ejkmoz]|(?:edu|e[cegrstu])|f[ijkmor]|(?:gov|g[abdefghilmnpqrstuwy])|h[kmnrtu]|(?:info|int|i[delmnoqrst])|(?:jobs|j[emop])|k[eghimnrwyz]|l[abcikrstuvy]|(?:mil|mobi|museum|m[acdghklmnopqrstuvwxyz])|(?:name|net|n[acefgilopruz])|(?:org|om)|(?:pro|p[aefghklmnrstwy])|qa|r[eouw]|s[abcdeghijklmnortuvyz]|(?:tel|travel|t[cdfghjklmnoprtvwz])|u[agkmsyz]|v[aceginu]|w[fs]|y[etu]|z[amw]))|(?:(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9])\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[0-9])))(?:\:\d{1,5})?)(\/(?:(?:[a-zA-Z0-9\;\/\?\:\@\&\=\#\~\-\.\+\!\*\'\(\)\,\_])|(?:\%[a-fA-F0-9]{2}))*)?(?:\b|$)/i
					let intRes = /\[[^\]]*\]/
					let replacedRow = []
					while(row.search(urlRegex) != -1){
					  let startOfHref = row.search(urlRegex)

					  replacedRow.push(row.substr(0, startOfHref))
					  row.replace(urlRegex, (url) => {
						replacedRow.push(<a href={(url.substr(0, 3) == 'htt')? url : 'http://' + url} target="_blank">{url}</a>)
						row = row.substr(startOfHref + url.length)
					  })
					}
					// while()
					while(row.search(intRes) != -1){
						let startOfLink = row.search(intRes)
						replacedRow.push(row.substr(0, startOfLink))
						row.replace(intRes, (url) => {
							let id = url.substr(1, url.length - 2)
							if(!o.data[id]){
								replacedRow.push(`[${url.substr(1, url.length - 2)}]`)
								row = row.substr(startOfLink + url.length + 1)
							}else{
								let catalog = (o.data[id].type == 'property')?
												'property/'
												: (o.data[id].type == 'tenant')?
													'tenant/'
													: (o.data[id].type == 'repairman')?
														'repairman/'
														: (o.data[id].type == 'task')?
															'task/'
															: ''
								replacedRow.push(
									<Link
										to={
											'http://test.localhost:3000/' + catalog + id
										}
										title={o.data[id].type}
										className="highlight-hover"
									>
										{(o.data[id].type == 'property')?
											o.data[id].alias
											: (o.data[id].type == 'tenant')?
												`${o.data[id].firstName} ${o.data[id].lastName}`
												: (o.data[id].type == 'repairman')?
													o.data[id].firstName
													: (o.data[id].type == 'task')?
														o.data[id].taskContent
														: ''
										}
									</Link>
								)
								row = row.substr(startOfLink + url.length + 1)
							}
						})
					}
					replacedRow.push(row)

					return(
						<p
							style={{
								margin: '2px 0'
							}}
							key={indexRow}
						>
							{replacedRow.map(el => el)}
						</p>
					)
				}
			)
		}
		children={
			<p style={{
					float: 'right'
					, fontSize: '12px'
					, color: '#A0A0A0'
					, fontStyle: 'italic'
				}}>
				{`Posted
					${(Moment().diff(Moment(o.props.date), 'days') > 6)?
					`on ${Moment(o.props.date).format('MMM DD h:mma')}`
						:(Moment().diff(Moment(o.props.date), 'days') > 1)?
							Moment(o.props.date).format('dddd at h:mma')
								: (Moment().diff(Moment(o.props.date), 'hours') > 1)?
									`${Moment().diff(
											Moment(o.props.date)
										  , 'hours'
										)
									} hours ago`
										: `${Moment().diff(
												Moment(o.props.date)
											  , 'minutes'
											)
										} minutes ago`
					}
				`}
			</p>
		}
	/>
)



// WEBPACK FOOTER //
// ./src/routes/manager/search/ResultCard.js